import { render, staticRenderFns } from "./OrganizationTag.vue?vue&type=template&id=2a489e4a&scoped=true&"
import script from "./OrganizationTag.vue?vue&type=script&lang=js&"
export * from "./OrganizationTag.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationTag.vue?vue&type=style&index=0&id=2a489e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a489e4a",
  null
  
)

export default component.exports